module.exports = __webpack_public_path__ + "img/567x600px-Asztalos.232181a4.jpg";